import Utils from "../../services/Utils.js";
import { getGames } from "../../js/api/gameByLeagues.js";
import { getGameTemplate } from "../templates/game.js";

import { sports } from "../components/Leftpanel.js";
import { leagues } from "./League.js";
import { _t } from "../../services/TranslationService.js";

var leagueId = 0;
let Games = {
  render: async () => {
    let request = Utils.parseRequestURL();
    leagueId = request.id;

    let games = await getGames(request.id);
    let gamesOutright = await getGames(446);

    console.log(gamesOutright, "asdasdasdas 123 123 123");
    const uniqueDates = [
      ...new Set(games.map((item) => item.game_date)),
    ].sort();

    let sportName = games[0].sport;
    let countryName = games[0].country;
    let leagueName = games[0].league;
    let columns = "";
    try {
      columns = games[0].odd.split(",").length == 2 ? "twoColumn" : "";
    } catch {}

    let sportsView = "";
    sports.forEach((sport) => {
      sportsView =
        sportsView +
        `<a href="#/categories/${sport.id}" class="betModuleSportBtn active hd-${sport.name}">
                       <i class="sport-${sport.name}"></i>
                       <span>${_t(sport.name)}</span>
                     </a>`;
    });

    let gamesView = "";

    uniqueDates.forEach((date) => {
      let singleDateView = "";

      games
        .filter((a) => a.game_date === date)
        .map((game) => {
          if (!game.odd) {
            return;
          }
          singleDateView += getGameTemplate(game);
        });

      gamesView =
        gamesView +
        ` <div class="gameTableContent">
                <div class="singleGameDateLabel">
                   <span>${date}</span>
                   <span>1</span>
                   <span>X</span>
                   <span>2</span>
                </div>
                <div>
                  ${singleDateView}
                </div>
            </div>`;
    });

    if (gamesView === "") {
      gamesView = `<h3>${_t("Ska loje")}</h3>`;
    }
    // let posts = await getPostsList()
    let view = /*html*/ `
            <div class="pageHeaderTitle">
                <a class="backBtn">
                    <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#939393" d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
                </a>
                <span>${sportName} / ${countryName} - ${leagueName}</span>
            </div>
            <div class="countryHeaderLabel pr-bree">
                <span>${games[0].league}</span>
            </div>
            <div id="pre-match-games" class="${columns}">
              <div class="gameTableContent">
                  ${gamesView}
              </div>
            </div>
       `;
    return view;
  },
  after_render: async (socket) => {
    socket.emit("connectToRoom", { room: "prematch-games" });
    socket.on("new-game", (data) => {
      if (data.league == leagueId) {
        const game = document.getElementById(data.id);

        if (!game) {
          let liveGameContainer = document.getElementById("pre-match-games");
          if (liveGameContainer) {
            const template = getGameTemplate(data);
            liveGameContainer.innerHTML =
              liveGameContainer.innerHTML + template;
          }
        } else {
          game.innerHTML = getGameTemplate(data);
        }
      }
    });
  },
  on_unload: async (socket) => {
    socket.emit("leaveRoom", { room: "prematch-games" });
  },
};

export default Games;
